import React, { Component } from 'react';
import { getUser } from '../../actions/session';
import DatePicker from "react-datepicker";
import CustomLoader from '../common/loader';
import axiosInstance from '../../config/axiosConfig';
import { OUTBOUND_STATS_API } from '../../config/rest_endpoints';
import { Notifications } from '../common/notification';
import moment from 'moment';
import { withRouter } from 'react-router';

class OutBoundStats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            data: [],
            startDate: new Date(),
            endDate: new Date(),
            isGetting: false,
            isLoad: false,
            sortConfig: { key: 'createDate', direction: 'desc' }
        };
    }

    componentDidMount() {
        this.getReportOnSelectDate();
    }

    handleDate = (date, value) => {
        const key = value === "start" ? 'startDate' : 'endDate';
        this.setState({ [key]: date });
    }

    getReportOnSelectDate = () => {
        const { User, startDate, endDate } = this.state;
        if (!User || !User.id) return;
        const payload = {
            "startDate": moment(startDate).startOf('day').format('MM/DD/YYYY, hh:mm:ss A'),
            "endDate": moment(endDate).endOf('day').format('MM/DD/YYYY, hh:mm:ss A')
        };

        this.setState({ isGetting: true, isLoad: true });
        // Using axiosInstance which automatically adds auth header and handles 401 errors
        axiosInstance.post(`${OUTBOUND_STATS_API}/${User.id}`, payload)
            .then(res => {
                const resp = res.data.data || [];
                this.setState({ data: resp, isGetting: false, isLoad: false });
            })
            .catch(err => {
                this.setState({ isGetting: false, isLoad: false });
                // 401/JWT expiry is handled by axiosInstance interceptor
                if (err.response && err.response.status !== 401) {
                    const alert = err.response;
                    if (alert?.data?.message !== 'invalid or expired jwt') {
                        Notifications.notify(alert?.data?.message || "Error", "Failed", "error");
                    }
                }
            });
    }

    // Sorting Logic
    handleSort = (key) => {
        let direction = 'asc';
        if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const sortedData = [...this.state.data].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        this.setState({ data: sortedData, sortConfig: { key, direction } });
    }

    renderSumRow() {
        const { data } = this.state;
        if (data.length < 2) return null;

        // Aggregate totals for all numeric columns
        const totals = data.reduce((acc, row) => {
            acc.cost += Number(row.revenue || 0); // Mapping 'revenue' API field to 'cost'
            acc.minutes += Number(row.minutes || 0);
            acc.completed += Number(row.completed || 0);
            acc.inCalls += Number(row.inCalls || 0);
            acc.sdCount += Number(row.sdCount || 0);
            acc.rejectedForCapacity += Number(row.rejectedForCapacity || 0);
            acc.indeterminateMinutes += Number(row.indeterminateMinutes || 0);
            acc.intrastateMinutes += Number(row.intrastateMinutes || 0);
            acc.interstateMinutes += Number(row.interstateMinutes || 0);
            acc.dcnCount += Number(row.dcnCount || 0);
            return acc;
        }, {
            cost: 0, minutes: 0, completed: 0, inCalls: 0, sdCount: 0,
            rejectedForCapacity: 0, indeterminateMinutes: 0,
            intrastateMinutes: 0, interstateMinutes: 0, dcnCount: 0
        });

        // Statistical Logic
        const totalACD = totals.completed > 0 ? (totals.minutes * 60) / totals.completed : 0;
        const totalSDP = totals.completed > 0 ? (totals.sdCount / totals.completed) * 100 : 0;
        const totalASR = totals.inCalls > 0 ? (totals.completed / totals.inCalls) * 100 : 0;

        return (
            <tr className="bg-dark font-weight-bold">
                <td className="text-left">TOTAL</td>
                <td className="text-right">{totals.cost.toFixed(2)}</td>
                <td className="text-right">{totals.minutes.toFixed(2)}</td>
                <td className="text-right">{totalACD.toFixed(2)}</td>
                <td className="text-right">{totalSDP.toFixed(2)}</td>
                <td className="text-right">{totalASR.toFixed(2)}%</td>
                <td className="text-right">{totals.completed}</td>
                <td className="text-right">{totals.inCalls}</td>
                <td className="text-right">{totals.sdCount}</td>
                <td className="text-right">{totals.rejectedForCapacity}</td>
                <td className="text-right">{totals.indeterminateMinutes.toFixed(2)}</td>
                <td className="text-right">{totals.intrastateMinutes.toFixed(2)}</td>
                <td className="text-right">{totals.interstateMinutes.toFixed(2)}</td>
                <td className="text-right">{totals.dcnCount}</td>
            </tr>
        );
    }

    renderReportTable() {
        const { data } = this.state;
        return data.map((row, idx) => (
            <tr key={idx}>
                <td className="text-left">{moment.utc(row.createDate).local().format('DD-MMM-YYYY')}</td>
                <td className="text-right">{Number(row.revenue).toFixed(2)}</td>
                <td className="text-right">{Number(row.minutes).toFixed(2)}</td>
                <td className="text-right">{Number(row.ACD).toFixed(2)}</td>
                <td className="text-right">{Number(row.SDP).toFixed(2)}</td>
                <td className="text-right">{Number(row.ASR).toFixed(2)}%</td>
                <td className="text-right">{row.completed}</td>
                <td className="text-right">{row.inCalls}</td>
                <td className="text-right">{row.sdCount}</td>
                <td className="text-right">{row.rejectedForCapacity}</td>
                <td className="text-right">{Number(row.indeterminateMinutes).toFixed(2)}</td>
                <td className="text-right">{Number(row.intrastateMinutes).toFixed(2)}</td>
                <td className="text-right">{Number(row.interstateMinutes).toFixed(2)}</td>
                <td className="text-right">{row.dcnCount}</td>
            </tr>
        ));
    }
    render() {
        const { startDate, endDate, isGetting, isLoad, data } = this.state;
        const headers = [
            { label: 'Date', key: 'createDate', align: 'text-left' },
            { label: 'Cost', key: 'revenue', align: 'text-right' },
            { label: 'Minutes', key: 'minutes', align: 'text-right' },
            { label: 'ACD', key: 'ACD', align: 'text-right' },
            { label: 'SDP', key: 'SDP', align: 'text-right' },
            { label: 'ASR', key: 'ASR', align: 'text-right' },
            { label: 'Completed', key: 'completed', align: 'text-right' },
            { label: 'In Calls', key: 'inCalls', align: 'text-right' },
            { label: 'SD Count', key: 'sdCount', align: 'text-right' },
            { label: 'Rejected', key: 'rejectedForCapacity', align: 'text-right' },
            { label: 'Indet. Min', key: 'indeterminateMinutes', align: 'text-right' },
            { label: 'Intra Min', key: 'intrastateMinutes', align: 'text-right' },
            { label: 'Inter Min', key: 'interstateMinutes', align: 'text-right' },
            { label: 'DNC', key: 'dcnCount', align: 'text-right' }
        ];

        return (
            <div className="card">
                <div className="card-header" style={{ overflow: 'visible', zIndex: 10, position: 'relative' }}>
                    <div className="d-flex align-items-end">
                        <div className="mr-3">
                            <label className="d-block fs-14">Start Date (UTC)</label>
                            <DatePicker selected={startDate} onChange={d => this.handleDate(d, "start")} dateFormat="MMMM d, yyyy" className="form-control" />
                        </div>
                        <div className="mr-3">
                            <label className="d-block fs-14">End Date (UTC)</label>
                            <DatePicker selected={endDate} onChange={d => this.handleDate(d, "end")} dateFormat="MMMM d, yyyy" className="form-control" />
                        </div>
                        <button className="btn btn-primary" onClick={this.getReportOnSelectDate} disabled={isLoad}>
                            Search {isLoad ? <i className="icon-spinner2 spinner ml-2"></i> : <i className="icon-filter4 ml-2"></i>}
                        </button>
                    </div>
                </div>

                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead className="bg-dark text-white">
                            <tr>
                                {headers.map(h => (
                                    <th key={h.key} onClick={() => this.handleSort(h.key)} style={{ cursor: 'pointer' }} className={h.align}>
                                        {h.label} <i className="icon-sort-alpha-asc ml-1" style={{ fontSize: '10px' }}></i>
                                    </th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {isGetting ? (
                                <CustomLoader colSpan={14} message="Loading stats..." />
                            ) : (
                                data.map((row, idx) => (
                                    <tr key={idx}>
                                        <td className="text-left">{moment.utc(row.createDate).local().format('DD-MMM-YYYY')}</td>
                                        <td className="text-right">{Number(row.revenue).toFixed(2)}</td>
                                        <td className="text-right">{Number(row.minutes).toFixed(2)}</td>
                                        <td className="text-right">{Number(row.ACD).toFixed(2)}</td>
                                        <td className="text-right">{Number(row.SDP).toFixed(2)}</td>
                                        <td className="text-right">{Number(row.ASR).toFixed(2)}%</td>
                                        <td className="text-right">{row.completed}</td>
                                        <td className="text-right">{row.inCalls}</td>
                                        <td className="text-right">{row.sdCount}</td>
                                        <td className="text-right">{row.rejectedForCapacity}</td>
                                        <td className="text-right">{Number(row.indeterminateMinutes).toFixed(2)}</td>
                                        <td className="text-right">{Number(row.intrastateMinutes).toFixed(2)}</td>
                                        <td className="text-right">{Number(row.interstateMinutes).toFixed(2)}</td>
                                        <td className="text-right">{row.dcnCount}</td>
                                    </tr>
                                ))
                            )}
                            {!isGetting && this.renderSumRow()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(OutBoundStats);